module.exports = __webpack_public_path__ + "static/media/arrow-right-blue.b5ff8fa6.svg";